import { Modal, Button , Select } from 'antd'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { http } from '@services/http'

export default function SelectServiceModal({ visible, service, handleSelect }) {
	const { t } = useTranslation()
	const { getMe } = useSelector((state) => state.main)

	const [services, setServices] = React.useState([])
	const [loading, setLoading] = React.useState(false)

	const getServices = async (servicesWork) => {
		setLoading(true)
		try {
			const { data } = await http.get(
				`api/items/worker-services/${servicesWork}`,
			)
			setServices(data[0]?.WORKER_RCollection)
		} catch (error) {
		} finally {
			setLoading(false)
		}
	}

	useEffect(() => {
		getServices(getMe?.servicesWork)
	}, [getMe])

	const serviceOptions = services?.map((service, index) => ({
		value: service?.U_ServicesCode,
		label: `${service?.U_ServicesCode} - ${service?.U_ServicesName}`,
		key: index,
	}))

	const [item, setItem] = React.useState('')

	return (
		<Modal open={visible} footer={null} closable={false}>
			<div className="flex flex-col items-center justify-between">
				<p className="font-bold text-lg text-center">
					{t('selectServiceRequired')}
				</p>

				<Select
					value={item}
					options={serviceOptions}
					onChange={(value) => setItem(value)}
					loading={loading}
					className="w-[300px] mt-10"
					// showSearch
					// filterOption={(input, option) =>
					// 	option.children.toLowerCase().includes(input.toLowerCase())
					// }
				/>

				<Button
					key="yes"
					disabled={!item}
					className="bg-[#0A4D68] text-white mt-5"
					onClick={() => handleSelect(item)}
				>
					{t('select')}
				</Button>
			</div>
		</Modal>
	)
}
